import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const BulletList = styled.ul`
  margin: 0;
  padding-left: 20px;

  display: flex;
  flex-direction: column;
  row-gap: 8px;

  // The global reset sets list-style-type: none on every ul
  list-style-type: disc;

  color: ${({ theme }) => theme.colors.greys.darkest};
  font: ${({ theme }) => theme.fonts.textBigHeight24};
`;
